import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment'; 
import { AppComponent } from './app.component';
import { APP_ROUTES } from './app.routes';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { from } from 'rxjs';
import { pluck } from 'rxjs/operators';
import {ToastModule} from 'primeng/toast';
// import {DialogModule} from 'primeng/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';





export class WebpackTranslateLoader implements TranslateLoader {
  getTranslation(lang: string) {
      return from(import(`../assets/i18n/${lang}.json`)).pipe(pluck('default'));
  }
}
@NgModule({
  declarations: [
    AppComponent,
    
  ],
  imports: [
    APP_ROUTES,
    BrowserAnimationsModule,

    MatTooltipModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: WebpackTranslateLoader
      }
    }),
    SharedModule,
    CoreModule,
    ToastModule,
    //DialogModule
  ],
  providers: [
  
    provideAnimationsAsync()
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }